/**
 * 콘텐츠 블록 폼 — 유형(text/longtext/image/video) 선택에 따라 콘텐츠 패널을 전환한다.
 *
 * 마크업 계약 (resources/views/admin/pages/content-blocks/_form-fields.php):
 *   - [data-content-type-select]  : 유형 <select> (create 화면에만 존재)
 *   - [data-content-type-panel="text|longtext|image|video"] : 유형별 콘텐츠 패널
 *
 * 선택된 유형의 패널만 보이고 나머지는 숨긴다. longtext 패널이 보이는 순간
 * 그 안의 리치 에디터를 lazy-mount 한다(숨김 상태 Quill 0높이 방지). edit 화면은
 * select 가 없어(유형 고정) 초기 hidden 상태가 그대로 유지된다.
 */
import { RichEditor } from "../../components/RichEditor";

function applyTypePanels(root: ParentNode, type: string): void {
  root.querySelectorAll<HTMLElement>("[data-content-type-panel]").forEach((panel) => {
    const match = panel.getAttribute("data-content-type-panel") === type;
    panel.classList.toggle("is-hidden", !match);
    panel.hidden = !match;
    // 패널이 보이는 순간, 그 안의 리치 에디터를 lazy-mount(멱등). 보인 뒤 마운트라 0높이 문제 없음.
    if (match) {
      panel.querySelectorAll<HTMLElement>("[data-rich-editor]").forEach((host) => RichEditor.mountOne(host));
    }
  });
}

export function initContentBlockTypeToggle(): void {
  const selects = document.querySelectorAll<HTMLSelectElement>("[data-content-type-select]");
  selects.forEach((select) => {
    const form = select.closest("form") ?? document;
    applyTypePanels(form, select.value);
    select.addEventListener("change", () => applyTypePanels(form, select.value));
  });
}
